var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex align-items-center w-100" },
    [
      _c("div", [
        _c("img", {
          staticClass: "round",
          attrs: {
            src:
              _vm.user.avatar !== null
                ? _vm.user.avatar.url
                : "/images/avatar.png",
            alt: "avatar",
            height: "25",
            width: "25",
          },
        }),
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "font-weight-bold ml-05 mr-05 mb-0" }, [
        _vm._v(_vm._s(_vm.user.first_name) + " " + _vm._s(_vm.user.last_name)),
      ]),
      _vm._v(" "),
      _vm._l(_vm.user.badges, function (badge) {
        return _c("span", [
          _c("img", {
            staticStyle: { "margin-top": "-3px", height: "12px" },
            attrs: {
              src: badge.image,
              "data-toggle": "tooltip",
              alt: "Badge Image",
              "data-placement": "bottom",
              title: badge.name,
            },
          }),
        ])
      }),
      _vm._v(" "),
      _vm.user.user_badge_name !== null && _vm.user.user_badge_icon !== null
        ? _c("img", {
            staticStyle: { "margin-top": "-3px", height: "12px" },
            attrs: {
              src: _vm.user.user_badge_image.url,
              "data-toggle": "tooltip",
              "data-placement": "bottom",
              alt: "Badge Image",
              title: _vm.user.user_badge_name,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "ml-auto" }, [
        _c("div", { staticClass: "ml-1" }, [
          !_vm.isInvited
            ? _c("span", [
                _c(
                  "button",
                  {
                    staticClass: "btn-sm btn-outline-primary",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.invite()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("group.form.buttons.invite")))]
                ),
              ])
            : _c("span", [
                _c(
                  "button",
                  {
                    staticClass: "btn-sm btn-outline-danger",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.removeInvite()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.__("group.form.buttons.delete_invite")))]
                ),
              ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }